/*
 * PAWS & PEARLS — THE MUSE — PEARL & ROSE-GOLD FLYING TOAD V1
 * Installation candidate · MAGICAL MUSE WORLD duplicate Shopify theme.
 * ONE independent, removable foreground visitor. NO audio.
 * Flight V18, Journey, lookout, companions, birds, hippo, Lilla, sound,
 * sky scroll behavior, and 32 pearls are NEVER modified.
 *
 * Uses 24 provisional transparent cutouts from the approved motion preview,
 * packed into one 6 x 4 WEBP atlas. The archived original PNGs are unchanged.
 *
 * Rollback: remove ONLY this file's <script ...> tag from V18 Custom Liquid.
 */
(function () {
  'use strict';

  var script = document.currentScript ||
    document.querySelector('script[data-pp-muse-flying-toad-v1]');
  var atlasURL = script && script.getAttribute('data-toad-atlas');
  if (!atlasURL || !/^(https?:\/\/|\/)/.test(atlasURL)) return;
  if (window.ppMuseFlyingToadV1 && window.ppMuseFlyingToadV1.installed) return;

  // MADAM'S ADJUSTMENT DESK — ONLY these settings need to change in QA.
  var CONFIG = Object.freeze({
    START_AFTER_CLICK_MS: 26000, // Toad arrives during the Secret Sky visit
    DURATION_MS: 18000,         // One leisurely 18-second appearance
    LOWER_SCENE_LIFT: 0.00,     // IMPORTANT: raises path above the real lower visible edge
    HORIZONTAL_SHIFT: -0.3,        // E.g. +0.05 moves the entire route right
    SIZE_MULTIPLIER: 0.45,      // E.g. .85 smaller; 1.15 larger
    Z_INDEX: 2147483002,      // Foreground, above balloon/cloud; never clickable
    MAX_DESKTOP_PX: 188,
    MIN_DESKTOP_PX: 74,
    MAX_MOBILE_PX: 120,
    MIN_MOBILE_PX: 64
  });

  var NS = 'ppMuseFlyingToadV1';
  var ROOT_ID = 'pp-muse-secret-sky';
  var STAGE_ID = 'pp-muse-balloon-stage';
  var LAYER_ID = 'pp-muse-flying-toad-layer-v1';
  var STYLE_ID = LAYER_ID + '-style';

  // Exact path approved in the 18-second movement preview.
  // [second, x / 960, y / 600, relative sprite width, tilt in degrees].
  var PATH = [[0,95,478,108,0],[0.8,148,415,112,-9],[1.65,182,495,109,8],[2.45,263,420,115,-7],[3.2,283,466,106,3],[4.2,376,370,119,-9],[5.0,420,442,111,3],[6.0,528,352,117,-9],[7.2,603,437,113,4],[8.2,682,360,121,-8],[9.4,688,395,123,0],[10.3,636,442,116,7],[11.1,571,358,113,-7],[12.0,505,430,106,4],[13.05,423,492,116,-2],[13.95,332,410,119,8],[15.0,225,508,112,-4],[16.2,167,454,106,5],[17.0,164,469,106,0],[18.0,164,472,106,0]];

  var atlas = new Image();
  var atlasReady = false;
  var atlasFailed = false;
  atlas.decoding = 'async';
  atlas.onload = function () { atlasReady = true; };
  atlas.onerror = function () { atlasFailed = true; console.warn('[P&P Toad] Atlas could not load.'); };
  atlas.src = atlasURL;
  if (atlas.complete && atlas.naturalWidth > 0) atlasReady = true;
  if (typeof atlas.decode === 'function') {
    atlas.decode().then(function () { atlasReady = true; }, function () {
      if (atlas.complete && atlas.naturalWidth) atlasReady = true;
    });
  }

  var layer = null;
  var actor = null;
  var current = null;
  var raf = 0;
  var installed = false;
  var clickOriginMs = 0;
  var lastPose = -1;
  var disposed = false;

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function clamp(min, value, max) { return Math.min(max, Math.max(min, value)); }
  function ease(t) { t = clamp(0,t,1); return t*t*(3-2*t); }
  function mix(a,b,t) { return a+(b-a)*t; }
  function isSkyPage() { return document.documentElement.classList.contains('pp-muse-secret-sky-page'); }

  function style() {
    if (document.getElementById(STYLE_ID)) return;
    var css = document.createElement('style');
    css.id = STYLE_ID;
    css.textContent =
      '#' + LAYER_ID + '{position:fixed!important;inset:0!important;' +
      'z-index:' + CONFIG.Z_INDEX + '!important;pointer-events:none!important;' +
      'user-select:none!important;overflow:hidden!important;}' +
      '#' + LAYER_ID + ' .pp-toad-actor{position:absolute!important;left:0;top:0;' +
      'display:none;width:160px;height:160px;aspect-ratio:1/1;' +
      'pointer-events:none!important;user-select:none!important;' +
      'background-image:url("' + atlasURL.replace(/"/g,'%22') + '");' +
      'background-repeat:no-repeat;background-size:600% 400%;' +
      'background-position:0% 0%;opacity:1!important;will-change:transform,left,top;}' +
      '@media(prefers-reduced-motion:reduce){#' + LAYER_ID + '{display:none!important;}}';
    document.head.appendChild(css);
  }
  function setup() {
    if (!isSkyPage()) return false;
    var sky = document.getElementById(ROOT_ID);
    var stage = document.getElementById(STAGE_ID);
    var wrapper = document.querySelector('.page-wrapper');
    if (!sky || !stage || !wrapper || !wrapper.contains(sky) || !wrapper.contains(stage)) return false;
    if (layer && layer.isConnected) return true;
    style();
    layer = document.createElement('div');
    layer.id = LAYER_ID;
    layer.setAttribute('aria-hidden', 'true');
    actor = document.createElement('div');
    actor.className = 'pp-toad-actor';
    layer.appendChild(actor);
    document.body.appendChild(layer);
    installed = true;
    return true;
  }
  function visibleSky() {
    var sky = document.getElementById(ROOT_ID);
    var wrapper = document.querySelector('.page-wrapper');
    if (!sky || !wrapper) return null;
    var a = sky.getBoundingClientRect();
    var b = wrapper.getBoundingClientRect();
    // The actual artwork ends above the enlarged cloud corridor. Prioritise
    // the artwork rectangle so the toad does not hover below visible scenery.
    var scene = sky.querySelector('.pp-muse-sky-scene');
    if (scene) {
      var s = scene.getBoundingClientRect();
      if (s.width > 100 && s.height > 100) {
        a = {
          left:Math.max(a.left,s.left), top:Math.max(a.top,s.top),
          right:Math.min(a.right,s.right), bottom:Math.min(a.bottom,s.bottom)
        };
      }
    }
    var x1 = Math.max(0,a.left,b.left);
    var y1 = Math.max(0,a.top,b.top);
    var x2 = Math.min(window.innerWidth,a.right,b.right);
    var y2 = Math.min(window.innerHeight,a.bottom,b.bottom);
    if (x2-x1 < 210 || y2-y1 < 240) return null;
    return {left:x1,top:y1,width:x2-x1,height:y2-y1,bottom:y2};
  }
  function waypoint(t) {
    for (var i=0;i<PATH.length-1;i++) {
      var a=PATH[i],b=PATH[i+1];
      if (t>=a[0] && t<b[0]) {
        var q=ease((t-a[0])/(b[0]-a[0]));
        return [mix(a[1],b[1],q),mix(a[2],b[2],q),
                mix(a[3],b[3],q),mix(a[4],b[4],q)];
      }
    }
    return PATH[PATH.length-1].slice(1);
  }
  function frameNumber(t) {
    if (t < 3) return [1+Math.floor(t/.35)%6,false];
    if (t < 9.3) return [7+Math.floor((t-3)/.28)%12,false];
    if (t < 12.65) return [19+Math.floor((t-9.3)/.52)%6,false];
    if (t < 16) return [7+Math.floor((16-t)/.31)%12,true];
    return [1+Math.floor((t-16)/.55)%6,false];
  }
  function setPose(n) {
    if (n === lastPose) return;
    lastPose = n;
    var col = (n-1)%6, row = Math.floor((n-1)/6);
    actor.style.backgroundPosition = (col*20) + '% ' + (row*100/3).toFixed(5) + '%';
  }
  function hide() { if (actor) actor.style.display = 'none'; }
  function finish() {
    if (raf) cancelAnimationFrame(raf);
    raf = 0;
    current = null;
    lastPose = -1;
    hide();
  }
  function tick(now) {
    raf = 0;
    if (!current || disposed || document.hidden || reduced()) { finish(); return; }
    if (!isSkyPage() || !current.button.isConnected ||
        !current.button.classList.contains('pp-muse-flight-overlay')) { finish(); return; }
    var elapsed = now - clickOriginMs;
    if (elapsed > CONFIG.START_AFTER_CLICK_MS + CONFIG.DURATION_MS + 70) { finish(); return; }
    if (elapsed < CONFIG.START_AFTER_CLICK_MS || !atlasReady || atlasFailed) {
      hide(); raf = requestAnimationFrame(tick); return;
    }
    var bounds = visibleSky();
    if (!bounds) { hide(); raf = requestAnimationFrame(tick); return; }
    var t = clamp(0,(elapsed-CONFIG.START_AFTER_CLICK_MS)/1000,CONFIG.DURATION_MS/1000);
    var p = waypoint(t);
    var x = clamp(.04,p[0]/960 + CONFIG.HORIZONTAL_SHIFT,.96);
    var y = clamp(.17,p[1]/600 - CONFIG.LOWER_SCENE_LIFT + .006*Math.sin(t*4.2),.86);
    var width = bounds.width * (p[2] * 1.48 / 960) * CONFIG.SIZE_MULTIPLIER;
    var mobile = window.innerWidth < 768;
    width = mobile
      ? clamp(CONFIG.MIN_MOBILE_PX,width,CONFIG.MAX_MOBILE_PX)
      : clamp(CONFIG.MIN_DESKTOP_PX,width,CONFIG.MAX_DESKTOP_PX);
    var pose = frameNumber(t);
    setPose(pose[0]);
    actor.style.left = (bounds.left + x*bounds.width).toFixed(1) + 'px';
    actor.style.top = (bounds.top + y*bounds.height).toFixed(1) + 'px';
    actor.style.width = width.toFixed(1) + 'px';
    actor.style.height = width.toFixed(1) + 'px';
    actor.style.transform = 'translate3d(-50%,-50%,0) rotate(' + p[3].toFixed(2) +
      'deg) scaleX(' + (pose[1] ? -1 : 1) + ')';
    actor.style.display = 'block';
    raf = requestAnimationFrame(tick);
  }
  function start(event) {
    if (disposed || current || reduced() || !isSkyPage()) return;
    var clicked = event.target && event.target.closest && event.target.closest(
      '#pp-muse-balloon-stage .pp-balloon, .pp-muse-flight-overlay.pp-balloon'
    );
    if (!clicked || !clicked.classList.contains('pp-muse-flight-overlay')) return;
    if (!setup()) return;
    finish();
    current = {button:clicked};
    clickOriginMs = performance.now();
    raf = requestAnimationFrame(tick);
  }
  function unload(event) {
    if (event.target && document.getElementById(STAGE_ID) &&
        event.target.contains(document.getElementById(STAGE_ID))) {
      finish();
      if (layer) layer.remove(); layer=null; actor=null; installed=false;
    }
  }
  function initialise() { setup(); }
  document.addEventListener('click',start,false);
  document.addEventListener('shopify:section:unload',unload);
  document.addEventListener('shopify:section:load',initialise);
  window.addEventListener('pagehide',finish);
  document.addEventListener('visibilitychange',function () { if (document.hidden) finish(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialise,{once:true});
  else initialise();
  window[NS] = {
    version:'1.0-provisional-atlas-foreground',
    installed:true,
    getStatus:function () {
      return {layerPresent:!!(layer&&layer.isConnected),running:!!current,
        atlasReady:atlasReady,atlasFailed:atlasFailed,
        appearingAfterSeconds:CONFIG.START_AFTER_CLICK_MS/1000,
        appearanceDurationSeconds:CONFIG.DURATION_MS/1000,
        lowerSceneLift:CONFIG.LOWER_SCENE_LIFT,
        changesExistingAnimations:false,hasAudio:false};
    }
  };
})();
